module.exports = __webpack_public_path__ + "media/wizard-footer/basic-info-dog-f66ef592.svg";